// extracted by mini-css-extract-plugin
module.exports = {"explanation":"TypeExplanation_explanation__9zdyn"};